import Router, { Route } from 'preact-router';
import { SignedIn, SignedOut, RedirectToSignIn, useAuth } from '@clerk/clerk-react';
import { Landing } from './pages/Landing';
import { Dashboard } from './pages/Dashboard';
import { Interview } from './pages/Interview';
import { PublicProfile as PublicProfilePage } from './pages/PublicProfile';
import { PublicResume } from './pages/PublicResume';
import { Profile } from './pages/Profile';
import { Settings } from './pages/Settings';
import { Admin } from './pages/Admin';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { SignInPage } from './pages/SignIn';
import { SignUpPage } from './pages/SignUp';

export function App() {
	return (
		<Router>
			<Route path="/" component={LandingOrDashboard} />
			<Route path="/sign-in" component={SignInPage} />
			<Route path="/sign-in/:rest*" component={SignInPage} />
			<Route path="/sign-up" component={SignUpPage} />
			<Route path="/sign-up/:rest*" component={SignUpPage} />
			<Route path="/dashboard" component={ProtectedDashboard} />
			<Route path="/interview/:id?" component={ProtectedInterview} />
			<Route path="/profile" component={ProtectedProfile} />
			<Route path="/settings" component={ProtectedSettings} />
			<Route path="/admin" component={ProtectedAdmin} />
			<Route path="/terms" component={Terms} />
			<Route path="/privacy" component={Privacy} />
			{/* Public profile page */}
			<Route path="/b/:tenant" component={PublicProfileRoute} />
			<Route path="/b/:slug/resume" component={PublicResumeRoute} />
			{/* Legacy redirect */}
			<Route path="/u/:slug" component={RedirectToProfile} />
			<Route default component={NotFound} />
		</Router>
	);
}

// Landing page redirects to dashboard if signed in
function LandingOrDashboard() {
	const { isSignedIn, isLoaded } = useAuth();
	if (!isLoaded) return null;
	if (isSignedIn) {
		window.location.replace('/dashboard');
		return null;
	}
	return <Landing />;
}

// Public profile route (no auth required)
function PublicProfileRoute({ tenant }: { tenant: string }) {
	return <PublicProfilePage tenant={tenant} />;
}

// Public resume route
function PublicResumeRoute({ slug }: { slug: string }) {
	return <PublicResume slug={slug} />;
}

// Legacy /u/:slug redirect
function RedirectToProfile({ slug }: { slug: string }) {
	window.location.replace(`/b/${slug}`);
	return null;
}

function NotFound() {
	return (
		<div style={{ padding: '2rem', textAlign: 'center' }}>
			<h1>404 - Page Not Found</h1>
			<p>Path: {window.location.pathname}</p>
			<a href="/">Go Home</a>
		</div>
	);
}

// Protected route wrappers
function ProtectedDashboard() {
	return (
		<>
			<SignedIn>
				<Dashboard />
			</SignedIn>
			<SignedOut>
				<RedirectToSignIn />
			</SignedOut>
		</>
	);
}

function ProtectedInterview({ id }: { id?: string }) {
	return (
		<>
			<SignedIn>
				<Interview sessionId={id} />
			</SignedIn>
			<SignedOut>
				<RedirectToSignIn />
			</SignedOut>
		</>
	);
}

function ProtectedProfile() {
	return (
		<>
			<SignedIn>
				<Profile />
			</SignedIn>
			<SignedOut>
				<RedirectToSignIn />
			</SignedOut>
		</>
	);
}

function ProtectedSettings() {
	return (
		<>
			<SignedIn>
				<Settings />
			</SignedIn>
			<SignedOut>
				<RedirectToSignIn />
			</SignedOut>
		</>
	);
}

function ProtectedAdmin() {
	return (
		<>
			<SignedIn>
				<Admin />
			</SignedIn>
			<SignedOut>
				<RedirectToSignIn />
			</SignedOut>
		</>
	);
}
